import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import Popup from "src/components/Popup/Popup";
import { fetchCurrentAppVersion, markChangelogSeen, type AppVersionInfo } from "src/services/appVersion";

interface WhatsNewPopupProps {
    onClose: () => void;
}

export default function WhatsNewPopup({ onClose }: WhatsNewPopupProps) {
    const { t, i18n } = useTranslation();
    const [info, setInfo] = useState<AppVersionInfo | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        fetchCurrentAppVersion().then((v) => {
            if (cancelled) return;
            setInfo(v);
            setLoading(false);
            if (v) markChangelogSeen(v.version);
        });
        return () => { cancelled = true; };
    }, []);

    const isDe = i18n.language?.startsWith("de");
    const title = info ? (isDe ? info.titleDe || info.titleEn : info.titleEn || info.titleDe) : t("whatsNew.title");
    const bodyHtml = info ? (isDe ? info.bodyDe || info.bodyEn : info.bodyEn || info.bodyDe) : "";

    return (
        <Popup
            title={title}
            message={
                loading ? (
                    <p>…</p>
                ) : info ? (
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(bodyHtml) }} />
                ) : (
                    <p>{t("whatsNew.empty")}</p>
                )
            }
            actions={[{ label: t("popup.close"), onClick: onClose }]}
            onClose={onClose}
        />
    );
}
